import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { doAutionBid } from "../../../../redux/auction/action";
import Access from "../../../CustomComponents/Access/Access";
import ConfirmModal from "../../../Common/ConfirmModal";

export default function BitAuction({ getauctionbyid, setActiveTab }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [modal, setModal] = useState(false); // Access modal
  const [submitFunc, setSubmitFunc] = useState(null); // Access submit
  const [bidstate, setBidstate] = useState(0); // Access submit
  const [loading, setLoading] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false); // Confirmation modal
  const [pendingSubmit, setPendingSubmit] = useState(null); // Store wrapped submit

  // Yup validation schema
  const validationSchema = Yup.object().shape({
    bid: Yup.number().typeError("Bid must be a number")
      .required("Bid is required")
      .positive("Bid must be a positive number")
      .min(1, "Bid must be at least 1"),
  });

  // Actual bid submission
  const AutionBid = async (values, resetForm) => {
    setLoading(true);
    const data = {
      type: "1",
      price: values.bid,
      auction_id: id,
    };
    try {
      const res = await dispatch(doAutionBid(data));
      if (res.data.status) {
        resetForm(); // Reset input
        setActiveTab("bid");
        window.scrollTo({
          top: window.innerHeight + window.scrollY,
          behavior: "smooth",
        });
      }
    } catch (error) {
      console.error("Bid submission failed:", error);
    } finally {
      setLoading(false);
      setModal(false);
    }
  };

  // Show confirmation before Access modal
  const checkaccessss = (submitForm, resetForm, values, validateForm, setTouched) => {
    // Mark bid field as touched so error message appears
    setTouched({ bid: true });
    setBidstate(values?.bid)
    // Run validation manually
    validateForm().then((formErrors) => {
      if (Object.keys(formErrors).length > 0) {
        return; // Stop if validation fails
      }

      // Store pending submit wrapped with resetForm
      setPendingSubmit(() => () => {
        const wrappedSubmit = () => submitForm().then(() => resetForm());
        setSubmitFunc(() => wrappedSubmit);
        setModal(true); // show Access modal
      });

      setConfirmModal(true); // show confirmation modal
    });
  };

  return (
    <>
      {/* Confirmation Modal */}
      <ConfirmModal
        isOpen={confirmModal}
        toggle={() => setConfirmModal(false)}
        title="Confirm Bid"
        message={`You're about to bid $${bidstate}. Do you want to continue?`}
        onConfirm={() => pendingSubmit && pendingSubmit()}
      />

      <Formik
        initialValues={{ bid: "" }}
        validationSchema={validationSchema}
        onSubmit={(values, { resetForm }) => AutionBid(values, resetForm)}
        validateOnChange={true}
        validateOnBlur={true}
      >
        {({ submitForm, resetForm, values, validateForm, setTouched }) => (
          <>
            {/* Access modal for permission */}
            {modal && submitFunc && (
              <Access
                modal={modal}
                setModal={setModal}
                state={"state"}
                checkpermission={"bid_auction"}
                hitmethod={submitFunc} // wrapped submit
                masterID={getauctionbyid?.id}
                checkrole={false}
              />
            )}

            {/* Bid Form */}
            <Form className="input-button flex-wrap">
              <div className="d-flex align-items-center w-100" style={{ columnGap: '20px' }}>
                <div className="bid-input">
                  <Field
                    type="number"
                    name="bid"
                    className="form-control"
                    placeholder="Enter your bid"
                  />

                </div>

                <button
                  type="button"
                  className="btn purchase-btn w-100 dis-margin"
                  disabled={loading}
                  onClick={() => checkaccessss(submitForm, resetForm, values, validateForm, setTouched)}
                >
                  {loading
                    ? "Processing..."
                    : getauctionbyid?.my_bid > 0
                      ? "Update Bid"
                      : "Place Bid"}
                </button>
              </div>
              <div className="col-md-12">
                <ErrorMessage
                  name="bid"
                  component="div"
                  className="error-message text-danger"
                />
              </div>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
}
